import AxiosClient from "../AxiosClient";

export const postNewsSearchInfoListApi = (params) => {
  const url = "/api/news/searchInfoList";
  return AxiosClient.post(url, params);
};

export const searchSelectNews = (params) => {
  const url = "/api/news/searchSelectInfoList";
  return AxiosClient.post(url, params);
};

export const insertNews = (params) => {
  const url = "/api/news/insertInfo";
  return AxiosClient.post(url, params);
};

export const updateNews = (params) => {
  const url = "/api/news/updateInfo";
  return AxiosClient.post(url, params);
};

export const deleteNews = (params) => {
  const url = "/api/news/deleteInfo";
  return AxiosClient.post(url, params);
};
